<template>
  <div class="container">
    <div class="row privacy-policy">
      <PrivacyPolicyDE v-if="$i18n.locale === 'de'" />
      <PrivacyPolicyEN v-if="$i18n.locale === 'en'" />
    </div>
  </div>
</template>

<script>
import PrivacyPolicyDE from '@/components/privacy policies/de';
import PrivacyPolicyEN from '@/components/privacy policies/en';

export default {
  name: 'PrivacyPolicy',
  data() {
    return {

    };
  },
  components: {
    PrivacyPolicyDE,
    PrivacyPolicyEN,
  },
};
</script>

<style scoped>
  .privacy-policy {
    margin-top: 20px;
    margin-bottom: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/PrivacyPolicy.vue